
import {
    IconButton,
    ListItemIcon,
    ListItemText,
    MenuItem,
} from '@mui/material';
import { useTheme } from '@mui/styles';
import * as MaterialUIIcons from '../../../../app/common/controls/MaterialUIIcons';
import { AcosIcon } from '../AcosIcon';

export interface TreeCtxMenuProps {
    expandItem: () => void;
    expandeLessItem: () => void;
    expandAll: () => void;
    expandeLessAll: () => void;
}

export const TreeCtxMenu = ({
    expandItem,
    expandeLessItem,
    expandAll,
    expandeLessAll,
}: TreeCtxMenuProps) => {
    const theme = useTheme();
    return (
        <>
            <MenuItem onClick={expandItem}>
                <ListItemIcon>
                    <IconButton color="primary">
                        <MaterialUIIcons.ExpandMoreIcon fontSize="small" />
                    </IconButton>
                </ListItemIcon>
                <ListItemText primary="Utvid denne og underliggende" />
            </MenuItem>
            <MenuItem onClick={expandeLessItem}>
                <ListItemIcon>
                    <IconButton color="primary">
                        <MaterialUIIcons.ExpandLessIcon fontSize="small" />
                    </IconButton>
                </ListItemIcon>
                <ListItemText primary="Fold sammen denne og underliggende" />
            </MenuItem>
            {/* <MenuItem onClick={expandAll}>
                <ListItemIcon>
                    <IconButton color="primary">
                        <AcosIcon color={theme.palette.grey[600]}>unfold_more</AcosIcon>
                    </IconButton>
                </ListItemIcon>
                <ListItemText primary="Utvid alle" />
            </MenuItem> */}
            <MenuItem onClick={expandeLessAll}>
                <ListItemIcon>
                    <IconButton color="primary">
                        <AcosIcon color={theme.palette.grey[600]}>unfold_less</AcosIcon>
                    </IconButton>
                </ListItemIcon>
                <ListItemText primary="Fold sammen alle" />
            </MenuItem>
        </>
    );
};
